import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c5d6fff")

_pushScopeId("data-v-1c5d6fff")
const _hoisted_1 = { class: "admin-panel-referral" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "mb0 mr2 admin-panel-referral-use-budget" }
const _hoisted_4 = { class: "h3 flex items-center ml2" }
const _hoisted_5 = { class: "admin-panel-referral__budget ml1" }
const _hoisted_6 = { class: "h3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "admin-panel-referral__instructions flex items-center mt3" }
const _hoisted_10 = { class: "\n            admin-panel-referral__instructions-item\n            flex flex-column\n            items-center\n            center\n            justify-space-between\n          " }
const _hoisted_11 = { class: "admin-panel-referral__instructions-item-content" }
const _hoisted_12 = { class: "h3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "admin-panel-referral__divider" }, null, -1)
const _hoisted_14 = { class: "\n            admin-panel-referral__instructions-item\n            flex flex-column\n            items-center\n            center\n            justify-space-between\n          " }
const _hoisted_15 = { class: "admin-panel-referral__instructions-item-content" }
const _hoisted_16 = { class: "h3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "admin-panel-referral__divider" }, null, -1)
const _hoisted_18 = { class: "\n            admin-panel-referral__instructions-item\n            flex flex-column\n            items-center\n            center\n            justify-space-between\n          " }
const _hoisted_19 = { class: "admin-panel-referral__instructions-item-content" }
const _hoisted_20 = { class: "h3" }
const _hoisted_21 = { class: "flex flex-wrap" }
const _hoisted_22 = { class: "admin-panel-referral__invite mt3 mr4" }
const _hoisted_23 = { class: "h3" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", null, null, -1)
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "ml2" }
const _hoisted_27 = { class: "mt3" }
const _hoisted_28 = { class: "h3" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "h3 admin-panel-referral__code mr2" }
const _hoisted_31 = {
  key: 0,
  class: "mt3"
}
const _hoisted_32 = { class: "h3" }
const _hoisted_33 = { class: "h4 mr3" }
const _hoisted_34 = { class: "h4" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "my2" }, [
  /*#__PURE__*/_createTextVNode(" Icons made by "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://www.freepik.com",
    title: "Freepik"
  }, "Freepik"),
  /*#__PURE__*/_createTextVNode(" from "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://www.flaticon.com/",
    title: "Flaticon"
  }, "www.flaticon.com")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseButtonWithSpinner = _resolveComponent("BaseButtonWithSpinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t('adminPanel.referral.title')
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('adminPanel.referral.useBudget', {
              value: 'contact@getremotefun.com'
            })), 1),
          _createVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.referral.current')) + " ", 1),
            _createVNode("div", _hoisted_5, [
              _createVNode("b", null, _toDisplayString(_ctx.referralData.balance) + " " + _toDisplayString(_ctx.currency), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_BaseBox, { class: "admin-panel-referral__box" }, {
      default: _withId(() => [
        _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('adminPanel.referral.receiveMoney', {
            amount: _ctx.moneyForReferring[_ctx.currency],
            currency: _ctx.currency
          })), 1),
        _createVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.referral.sharingCaring')) + " ", 1),
          _hoisted_7,
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('adminPanel.referral.discountsAddUp')), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("img", {
              src: require(`@/assets/images/send.svg`),
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_11, [
              _createVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('adminPanel.referral.steps.referTitle')), 1),
              _createVNode("p", null, _toDisplayString(_ctx.$t('adminPanel.referral.steps.referDescription')), 1)
            ])
          ]),
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode("img", {
              src: require(`@/assets/images/money.svg`),
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_15, [
              _createVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('adminPanel.referral.steps.getMoneyTitle')), 1),
              _createVNode("p", null, _toDisplayString(_ctx.$t('adminPanel.referral.steps.getMoneyDescription')), 1)
            ])
          ]),
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            _createVNode("img", {
              src: require(`@/assets/images/buy.svg`),
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_19, [
              _createVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t('adminPanel.referral.steps.buyGamesFreeTitle')), 1),
              _createVNode("p", null, _toDisplayString(_ctx.$t('adminPanel.referral.steps.buyGamesFreeDescription')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("h3", _hoisted_23, _toDisplayString(_ctx.$t('adminPanel.referral.invite')), 1),
            _hoisted_24,
            _createVNode("div", _hoisted_25, [
              _createVNode(_component_Input, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                id: "email",
                type: "text",
                placeholder: "Email",
                class: "input--gray",
                onKeyup: _withKeys(_ctx.sendInvite, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"]),
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_BaseButtonWithSpinner, {
                  onClick: _ctx.sendInvite,
                  loading: _ctx.emailLoading
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.referral.send')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t('adminPanel.referral.yourCode')), 1),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, _toDisplayString(_ctx.referralCode), 1),
              _createVNode(_component_Button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copy(_ctx.referralCode)))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.referral.copyCode')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (_ctx.referralData.referredTo && _ctx.referralData.referredTo.length)
          ? (_openBlock(), _createBlock("div", _hoisted_31, [
              _createVNode("h3", _hoisted_32, _toDisplayString(_ctx.$t('adminPanel.referral.referralUsed')), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.referralData.referredTo, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.name,
                  class: "flex items-center my2"
                }, [
                  _createVNode("div", _hoisted_33, _toDisplayString(item.name), 1),
                  _createVNode("div", _hoisted_34, _toDisplayString(_ctx.getDate(item.used)), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_35
  ]))
})